import React, { Component } from 'react'
import SVGInline from 'react-svg-inline'

import urlFor, { QueryParams } from 'shared/tools/url-helper'

import EditIcon from 'client/shared/icons/edit.svg'

import './credit-card-edit-field.styl'

import Linka from 'client/shared/blocks/linka'
import CardLogo from 'client/shared/blocks/stripe-credit-card/card-logo'
import Button from 'client/shared/blocks/button'

import { RecurrentMetaCardInfo } from 'client/shared/types/subscription'

type Props = {
  login: string
  subscriptionId: string
  card: RecurrentMetaCardInfo
  kind: 'default' | 'big'
  query?: QueryParams
}

class CreditCardEditField extends Component<Props> {
  static defaultProps = {
    kind: 'default',
  }

  getCardInfo = (): { system: string; number: string } => {
    return {
      system: this.props.card.brand,
      number: `•••• •••• •••• ${this.props.card.last4}`,
    }
  }

  getChangeCardPath(): string {
    const { login, subscriptionId, query } = this.props
    return urlFor.changeCard(login, subscriptionId, query)
  }

  render(): JSX.Element {
    return this.props.kind === 'big' ? this.renderBig() : this.renderDefault()
  }

  renderDefault(): JSX.Element {
    const { system: cardSystem, number: cardNumber } = this.getCardInfo()

    return (
      <div className="credit-card-edit-field credit-card-edit-field_default">
        <Linka
          className="credit-card-edit-field__link"
          path={this.getChangeCardPath()}
        >
          <span className="credit-card-edit-field__card-logo">
            <CardLogo paymentSystem={cardSystem} />
          </span>
          <span className="credit-card-edit-field__card-number">
            {cardNumber}
          </span>
          <span className="credit-card-edit-field__icon">
            <SVGInline svg={EditIcon} />
          </span>
        </Linka>
      </div>
    )
  }

  renderBig(): JSX.Element {
    const { system: cardSystem, number: cardNumber } = this.getCardInfo()

    return (
      <div className="credit-card-edit-field credit-card-edit-field_big">
        <div className="credit-card-edit-field__card-number-wrapper">
          <span className="credit-card-edit-field__card-number">
            {cardNumber}
          </span>
          <span className="credit-card-edit-field__card-logo">
            <CardLogo paymentSystem={cardSystem} />
          </span>
        </div>
        <Button
          kind="transparent"
          type="inline"
          className="button_square"
          path={this.getChangeCardPath()}
          aria-label="credit card"
        >
          <SVGInline svg={EditIcon} className="credit-card-edit-field__icon" />
        </Button>
      </div>
    )
  }
}

export default CreditCardEditField
